import { message, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  SelectItem,
  ErrorItem,
} from "../../../../Components/Items";
import { TIPO_PERSONAL_OPTIONS } from "../../../../constants/nomina/repse";

const { Option } = Select;

class EditarPuesto extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    visible: this.props.visible,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState({ visible: this.props.visible });
      if (this.props.visible && this.props.puestoId) {
        this.formRef.current && this.formRef.current.resetFields();
        this.consultarDatosPuesto(this.props.puestoId);
      }
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  consultarDatosPuesto(id) {
    this.setState({ loading: true });
    axios
      .post(
        "puestos/datosPuesto",
        { puestoId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          message.error("No se encontraron los datos del puesto");
        } else {
          const { nombre, descripcion, tipoPersonal } = res.data.data;
          this.formRef.current && this.formRef.current.setFieldsValue({
            nombre,
            descripcion,
            tipoPersonal,
          });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "puestos/editarPuesto",
        {
          ...values,
          puestoId: this.props.puestoId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Puesto actualizado exitosamente");
          this.cerrarModal();
        } else {
          message.error("No se pudo actualizar el puesto");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  cerrarModal = () => {
    this.props.cerrarEditarPuesto();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  render() {
    return (
      <ModalItem
        title="Editar Puesto"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal}
        width={600}
      >
        <Form
          ref={this.formRef}
          name="modalEditarPuesto"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem
            name="nombre"
            label="Nombre del Puesto"
            required
            margin
          >
            <InputItem placeholder="Ingresa el nombre del puesto" />
          </FormItem>

          <FormItem
            name="tipoPersonal"
            label="Tipo de Personal"
            margin
          >
            <SelectItem placeholder="Tipo de personal (REPSE)" allowClear>
              {TIPO_PERSONAL_OPTIONS.map((value) => (
                <Option value={value} key={value}>
                  {value}
                </Option>
              ))}
            </SelectItem>
          </FormItem>

          <FormItem
            name="descripcion"
            label="Descripción"
            margin
          >
            <InputItem placeholder="Ingresa la descripción del puesto" />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EditarPuesto);